
/**
 * Service to handle storage operations via Cloudflare Pages Functions
 */

export interface UploadParams {
  file: File;
  tenantId: string;
  websiteId: string;
  category: 'sections' | 'popups' | 'assets';
}

export const uploadToR2 = async ({ file, tenantId, websiteId, category }: UploadParams): Promise<string> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('tenantId', tenantId);
  formData.append('websiteId', websiteId);
  formData.append('category', category);

  const response = await fetch('/api/upload', {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Upload failed');
  }

  const data = await response.json();
  return data.url;
};

/**
 * Extracts the R2 key from a public URL
 */
const getKeyFromUrl = (url: string): string | null => {
  try {
    const urlObj = new URL(url);
    // Pathname starts with /, we need everything after it
    return urlObj.pathname.startsWith('/') ? urlObj.pathname.slice(1) : urlObj.pathname;
  } catch {
    return null;
  }
};

/**
 * Deletes a single object or a "folder" prefix from R2
 */
export const deleteFromR2 = async (target: { url?: string; prefix?: string }): Promise<void> => {
  const key = target.url ? getKeyFromUrl(target.url) : null;
  const prefix = target.prefix;

  if (!key && !prefix) return;

  const response = await fetch('/api/delete', {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ key, prefix }),
  });

  if (!response.ok) {
    const error = await response.json();
    console.error('Failed to cleanup R2 storage:', error.message);
  }
};
